import api from './api';

export interface Cliente {
  id: number;
  nome: string;
  cpfCnpj: string;
  estadoCivil?: string;
  rg?: string;
  dataNascimento?: string | null;
  endereco?: string;
  profissao?: string;
  cep?: string;
  bairro?: string;
  numero?: string;
  cidade?: string;
  uf?: string;
  complemento?: string;
  telefoneComercial?: string;
  telefoneCelular?: string;
  telefoneResidencial?: string;
  telefone2?: string;
  email?: string;
  tipoPessoa: 'PF' | 'PJ';
  sexo?: string;
  dataEmissaoRg?: string | null;
  dataCnh?: string | null;
}

export interface CreateClienteDTO {
  nome: string;
  cpfCnpj: string;
  estadoCivil?: string;
  endereco?: string;
  rg?: string;
  dataNascimento?: string | null;
  profissao?: string;
  cep?: string;
  bairro?: string;
  numero?: string;
  cidade?: string;
  uf?: string;
  complemento?: string;
  telefoneComercial?: string;
  telefoneCelular?: string;
  telefoneResidencial?: string;
  telefone2?: string;
  email?: string;
  tipoPessoa: 'PF' | 'PJ';
  sexo?: string;
  dataEmissaoRg?: string | null;
  dataCnh?: string | null;
}



export const clienteService = {
  listar: async (search?: string, page: number = 1, limit: number = 10): Promise<{ data: Cliente[], total: number, page: number, limit: number }> => {
    const params: any = { page, limit };
    if (search) params.search = search;
    const response = await api.get('/clientes', { params });
    return response.data;
  },

 

  criar: async (cliente: CreateClienteDTO): Promise<Cliente> => {
    const response = await api.post('/clientes', cliente);
    return response.data;
  },

  atualizar: async (id: number, cliente: CreateClienteDTO): Promise<Cliente> => {
    const response = await api.put(`/clientes/${id}`, cliente);
    return response.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/clientes/${id}`);
  },

  detalhar: async (id: number): Promise<Cliente> => {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  }

}; 